import { render, staticRenderFns } from "./FarmerCollect.vue?vue&type=template&id=5d38fb9e&scoped=true"
import script from "./FarmerCollect.vue?vue&type=script&lang=js"
export * from "./FarmerCollect.vue?vue&type=script&lang=js"
import style0 from "./FarmerCollect.vue?vue&type=style&index=0&id=5d38fb9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d38fb9e",
  null
  
)

export default component.exports